import {Alias} from '@wandb/weave/components/Tag';
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React from 'react';

import {labelToOption} from './LogLabelFilter';

type LogLabelProps = {
  label?: string | null;
  maxLabelLength: number;
  truncatedMaxChars: number;
};

export const LogLabel = ({
  label,
  maxLabelLength,
  truncatedMaxChars,
}: LogLabelProps) => {
  // If there are NO labels at all, we don't need to render anything
  if (maxLabelLength === 0) {
    return null;
  }

  // Otherwise, render labels such that they align with the longest label across all lines.
  // We achieve this by adding whitespace characters to pad out the difference. This works
  // because we use a monospace font in the log container.

  const {value, displayText} = labelToOption(label);
  const isUnlabeled = !value;
  const whitespace =
    maxLabelLength > displayText.length
      ? '\u00a0'.repeat(maxLabelLength - displayText.length)
      : '';

  const aliasEl = (
    <Alias
      color="moon"
      label={displayText}
      maxChars={truncatedMaxChars}
      truncatedPart="middle"
    />
  );

  return (
    <span data-testid="label-container" className="flex shrink-0">
      {isUnlabeled ? (
        <Tooltip trigger={aliasEl} isTriggerAsChild={false} noTriggerWrap>
          <div className="w-[20rem]">
            Unlabeled logs are not captured from a defined label. The hardware
            source is not identifiable.
          </div>
        </Tooltip>
      ) : (
        aliasEl
      )}
      {whitespace.length > 0 && <span aria-hidden>{whitespace}</span>}
    </span>
  );
};
